<template>
  <v-dialog
    v-model="user_desactivated"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-card-title class="text-h5">
        Parece que seu usuário está desativado.
      </v-card-title>
      <v-card-text>
        <a :href="evolucional_redirect_url" class="text-sm">Ir para o evolucional</a>
      </v-card-text>
      <!-- <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="onConfirm"
        >
          OK
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { evolucional_redirect_url } from '../../constants/general';

export default {
  data(){
    return {
      evolucional_redirect_url,
    }
  },
  computed:{
    ...mapState({
      user_desactivated: state => state.user_desactivated,
    }),
  },
  methods:{
    ...mapActions([
      'isLoading'
    ]),
    onConfirm(){
      this.isLoading();
      window.location = "/admin/login";
    }
  }
}
</script>

